import axios from 'axios';
import { Production } from '../../system/environment';
import { firebase } from '../firebase/firebase';

export const urlBase = Production
  ? 'https://us-central1-universia-prod.cloudfunctions.net/'
  : 'https://us-central1-universia-dev.cloudfunctions.net/';

const headers = {
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json',
};

export const fetchDataGetAsync = async (url) => {
  try {
    const getData = await axios.request({
      url,
      method: 'GET',
      baseURL: urlBase,
      headers,
    });
    return getData.data;
  } catch (err) {
    const data = { ...err.response }.data.info;
    return { success: false, info: data };
  }
};

export const fetchDataPostAsync = async (url, sendable) => {
  try {
    const dataToken = await firebase?.auth()?.currentUser?.getIdTokenResult();
    if (dataToken?.token) {
      headers.authorization = `Bearer ${dataToken.token}`;
    }
    const getData = await axios.request({
      url,
      baseURL: urlBase,
      method: 'POST',
      data: sendable,
      headers,
    });
    return getData.data;
  } catch (err) {
    console.error({ ...err });
    const data = { ...err.response }.data.info;
    return { success: false, info: data };
  }
};

export const fetchDataPatchAsync = async (url, sendable) => {
  try {
    const getData = await axios.request({
      url,
      baseURL: urlBase,
      method: 'PATCH',
      data: sendable,
      headers,
    });
    return await getData.data;
  } catch (err) {
    console.error({ ...err });
    const data = { ...err.response }.data.info;
    return { success: false, info: data };
  }
};

export const fetchDataPostAsyncPrivate = async (url, sendable) => {
  try {
    const dataToken = await firebase.auth().currentUser.getIdTokenResult();
    headers.authorization = `Bearer ${dataToken.token}`;
    const getData = await axios.request({
      url,
      baseURL: urlBase,
      method: 'POST',
      data: sendable,
      headers,
    });
    return getData.data;
  } catch (err) {
    const data = { ...err.response }.data.info;
    return { success: false, info: data };
  }
};

export const fetchDataPostAsyncPrivateLocal = async (url, sendable) => {
  try {
    const dataToken = await firebase.auth().currentUser.getIdTokenResult();
    headers.authorization = `Bearer ${dataToken.token}`;
    const getData = await axios.request({
      url: `http://localhost:5001/pieza-development/us-central1/${url}`,
      method: 'POST',
      data: sendable,
      headers,
    });
    return getData.data;
  } catch (err) {
    const data = { ...err.response }.data.info;
    return { success: false, info: data };
  }
};


export const setDocumenteElastic = async (data) => {
  try {
    return await axios.request({
      baseURL: urlBase,
      url: "saveElasticAnyIndex",
      method: "post",
      data
    });
  } catch (e) {
    console.log(e);
    return false;
  }
};